import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * Create a WP RFC for the Real Physical Media hint in the "Copy URL" attchment field.
 *
 * @module others/rfcShortcutInfo
 */
import $ from "jquery";
import hooks from "../util/hooks";
import { rmlOpts } from "../util";
/**
 * Create a WP RFC for the Real Physical Media hint in the "Copy URL" attchment field.
 *
 * @property {id} id The attachment id.
 * @function shortcutInfo
 * @listens module:util/hooks#wprfc/$function
 */

hooks.register("wprfc/shortcutInfo", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var description, attachmentPageContainer, attachmentDialogContainer;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!window.realPhysicalMedia) {
            _context.next = 2;
            break;
          }

          return _context.abrupt("return");

        case 2:
          description = $('<p class="description" />');
          attachmentPageContainer = $("body.wp-admin.post-type-attachment .misc-pub-section.misc-pub-attachment");
          attachmentDialogContainer = $(this).parents(".attachment-details").find('.setting[data-setting="url"]'); // Avoid RC duplicate hints

          if (!attachmentDialogContainer.data("rpmHintAdded")) {
            _context.next = 7;
            break;
          }

          return _context.abrupt("return");

        case 7:
          attachmentDialogContainer.data("rpmHintAdded", true);

          if (!attachmentDialogContainer.length) {
            _context.next = 13;
            break;
          }

          // Media dialog
          attachmentDialogContainer.addClass("has-description");
          description = description.insertAfter(attachmentDialogContainer);
          _context.next = 18;
          break;

        case 13:
          if (!attachmentPageContainer.length) {
            _context.next = 17;
            break;
          }

          // Media page
          description = description.appendTo(attachmentPageContainer);
          _context.next = 18;
          break;

        case 17:
          return _context.abrupt("return");

        case 18:
          // Alter text for this description
          description.html(rmlOpts.others.lang.settingCopyLinkInfoRpm);

        case 19:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, this);
})));